export const handleRequestSort = (order, setOrder) => (event, property) => {
  const id = property;
  let direction = 'desc';

  if (order.id === property && order.direction === 'desc') {
    direction = 'asc';
  }

  setOrder({
    direction,
    id
  });
};

export const handleSelectAllClick = (setSelected, data) => event => {
  if (event.target.checked) {
    setSelected(data.map(n => n.id));
    return;
  }
  setSelected([]);
};

export const handleClick = (props, route) => item => {
  props.history.push(`${route}/${item.id}`);
};

export const handleCheck = (selected, setSelected) => (event, id) => {
  const selectedIndex = selected.indexOf(id);
  let newSelected = [];

  if (selectedIndex === -1) {
    newSelected = newSelected.concat(selected, id);
  } else if (selectedIndex === 0) {
    newSelected = newSelected.concat(selected.slice(1));
  } else if (selectedIndex === selected.length - 1) {
    newSelected = newSelected.concat(selected.slice(0, -1));
  } else if (selectedIndex > 0) {
    newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
  }

  setSelected(newSelected);
};

export const handleChangePage = setPage => (event, value) => {
  setPage(value);
};

export const handleChangeRowsPerPage = setRowsPerPage => event => {
  setRowsPerPage(event.target.value);
};

export const createSortHandler = props => property => event => {
  props.onRequestSort(event, property);
};

export const openSelectedRowsMenu = setSelectedOrdersMenu => event => {
  setSelectedOrdersMenu(event.currentTarget);
};

export const descendingComparator = (a, b, orderBy) => {
  const x = a[orderBy];
  const y = b[orderBy];

  if (!x || !y) {
    return 0;
  }

  if (x.toLowerCase() < y.toLowerCase()) {
    return -1;
  }
  if (x.toLowerCase() > y.toLowerCase()) {
    return 1;
  }
  return 0;
};

export const getComparator = (order, orderBy) => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

export const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
};
